import aviso from './aviso'
import emissaoSenha from './emissaoSenha'
import encaminhamento from './encaminhamento'
import filaAtendimento from './fila-atendimento'
import opcaoChamada from './opcaoChamada'
import opcaoEntrada from './opcaoEntrada'
import parametrizacao from './parametrizacao'
import prioridade from './prioridade'
import tela from './tela'
import tempoEspera from './tempoEspera'

export default [
    {
        path: 'painel-senha',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...emissaoSenha,
            ...encaminhamento,
            ...filaAtendimento,
            ...opcaoChamada,
            ...opcaoEntrada,
            ...parametrizacao,
            ...prioridade,
            ...tela,
            ...tempoEspera,
            ...aviso,
        ]
    }
]